// import { rServices } from '@/plugins/api';

import BaseModel from './base';

export default class ExpertiseCriteriaGroup extends BaseModel {
  constructor(group, url) {
    super(group, url);
    this.description = group.description || '';
    this.sets = group.sets || [];
  }
}
